const moment = require('moment');
class RebutFIltre {
    constructor(
        public any = moment().format("YYYY"),
        public idRebut = 0,
        public idContacte = "",
        public idRemesa = 0,
        public nomPagador = "",
        public nomInfant = "",
        public activitat = 0,
        public dataInici = "",
        public dataFi = "",
    ) {
        this.any = any;
        this.idRebut = idRebut;
        this.idContacte = idContacte;
        this.idRemesa = idRemesa;
        this.nomPagador = nomPagador;
        this.nomInfant = nomInfant;
        this.activitat = activitat;
        this.dataInici = dataInici;
        this.dataFi = dataFi;
    }
}

export default RebutFIltre;
